import Play from "../assets/media/play-icon.svg";
import { NavLink } from "react-router-dom";

const JackpotGamesSkeleton  = () => {
    
    return (
        <section className="container">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-heading-branded">
                            <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
                            <h2 className="section-heading-branded__text mb-0">Jackpot Games</h2>
                            <span className="section-heading-branded__star" aria-hidden="true">⭐</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="row gap-3 justify-content-center">
                            {
                                Array.from({ length: 15 }).map((m, i) => {
                                    return <div className="gameCard__wrapper" key={i}>
                                        <div className="gameCard__firstSection">
                                            <div className="first__data">
                                                <span className="gameCard__name"> 
                                                <div className="Polaris-SkeletonDisplayText__DisplayText Polaris-SkeletonDisplayText--sizeMedium"></div>    
                                                </span>
                                                <span className="gameCard__result"> ***-**-*** </span>
                                                <span className="gameCard__marketStatus gameCard__marketStatus--open">
                                                    Running for open
                                                </span>
                                            </div>
                                            <div className={"play__btn play__btn--animate"}>
                                                <img
                                                    alt=""
                                                    loading="lazy"
                                                    width={13}
                                                    height={13}
                                                    decoding="async"
                                                    data-nimg={1}
                                                    src={Play}
                                                    style={{
                                                        color: "initial",
                                                        filter: "none",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="gameCard__charts">
                                              <NavLink
                                                to={"/chart/jackpot"}
                                                className='gameCard__link'
                                            >
                                                Jodi Chart
                                            </NavLink>
                                        </div>
                                        <div className="result__time">
                                            <span>
                                                Open Bids : <strong> 12:00 AM </strong>
                                            </span>
                                            <span>
                                                Close Bids :<strong> 00:00 </strong>
                                            </span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JackpotGamesSkeleton ;
